export const GET_ALL_PAYMENT = "GET_PAYMENT";
export const GET_ALL_PAYMENT_SUCCESS = "GET_PAYMENT_SUCCESS";
export const GET_ALL_PAYMENT_FAILURE = "GET_PAYMENT_FAILURE";

export const GET_PAYMENT_METHODS = "GET_PAYMENT_METHODS";
export const GET_PAYMENT_METHODS_SUCCESS = "GET_PAYMENT_METHODS_SUCCESS";
export const GET_PAYMENT_METHODS_FAILURE = "GET_PAYMENT_METHODS_FAILURE";

export const RESET_PAYMENT = "RESET_PAYMENT";

export interface PaymentState {
  paymentMethods: any;
  paymentList: any;
  paymentSuccess: string | null;
  paymentError: string | null;
  paymentLoading: boolean;
}

interface GetPaymentAction {
  type: typeof GET_ALL_PAYMENT;
  payload: any;
}

interface GetPaymentSucess {
  type: typeof GET_ALL_PAYMENT_SUCCESS;
  payload: any;
}

interface GetPaymentFailure {
  type: typeof GET_ALL_PAYMENT_FAILURE;
  payload: string;
}

interface GetPaymentMethods {
  type: typeof GET_PAYMENT_METHODS;
  payload: any;
}

interface GetPaymentMethodsSuccess {
  type: typeof GET_PAYMENT_METHODS_SUCCESS;
  payload: any;
}

interface GetPaymentMethodsFailure {
  type: typeof GET_PAYMENT_METHODS_FAILURE;
  payload: any;
}

interface ResetPaymentAction {
  type: typeof RESET_PAYMENT;
}

export type PaymentActionTypes =
  | GetPaymentAction
  | GetPaymentSucess
  | GetPaymentFailure
  | GetPaymentMethods
  | GetPaymentMethodsSuccess
  | GetPaymentMethodsFailure
  | ResetPaymentAction;
